import { createBrowserRouter } from "react-router-dom";
import * as AuthComp from "./components/Auth";
import * as AboutComp from './components/About';
import * as AccountComp from "./components/Account";
import { lazy, Suspense } from "react";
import { Box, CircularProgress } from "@mui/material";
import { ProtectedRoute,PublicRoute } from "./FiltersRoutes.js";
import NotFound from "./components/common/NotFound.jsx";
// !-----------------Lazy Loading-----------------!
const LazyAuth = lazy(() => import('./pages/Auth.jsx'));
const LazyAbout = lazy(() => import('./pages/About.jsx'));
const LazyMainLanding = lazy(() => import('./pages/MainLanding.jsx'));
const LazyProductCategory = lazy(() => import('./pages/ProductCategory.jsx'));
const LazyProductNewArrival = lazy(() => import('./pages/NewArrivalProduct.jsx'));
const LazySearcedProduct = lazy(() => import('./pages/SearchedProductsPage.jsx'));
const LazyProductDetail = lazy(() => import('./pages/ProductDetail.jsx'));
const LazyCheckout = lazy(() => import('./pages/Checkout.jsx'));
const LazyThankyou = lazy(() => import('./pages/Thankyou.jsx'))
const LazyAccount = lazy(() => import('./pages/Account.jsx'));

// !-----------------Loader-----------------!
let loadCenter = {
  width: "100%",
  minHeight: "100vh",
  justifyContent: "center",
  alignItems: "center",
  display: "flex",
};

export const appRouter = createBrowserRouter([
  {
    path: "/",
    element: (
      <Suspense
        fallback={
          <Box sx={loadCenter}>
            <CircularProgress color="secondary" />
          </Box>
        }
      >
        <LazyMainLanding />
      </Suspense>
    ),
  },
  {
    path: "/auth",
    element: (
      <Suspense
        fallback={
          <Box sx={loadCenter}>
            <CircularProgress color="secondary" />
          </Box>
        }
      >
        <LazyAuth />
      </Suspense>
    ),
    children: [
      {
        path: "login", 
        element: <AuthComp.Login />
      },
      {
        path: "register",
        element: <AuthComp.Register />
      },
      {
        path:"forgot-password",
        element: <AuthComp.Forgotten />
      }
    ]
  },
  {
    path: "/about",
    element: (
      <Suspense
        fallback={
          <Box sx={loadCenter}>
            <CircularProgress color="secondary" />
          </Box>
        }
      >
        <LazyAbout />
      </Suspense>
    ),
    children: [
      {
        path: "aboutus", 
        element: <AboutComp.AboutUs />
      },
      {
        path: "termsandconditions",
        element: <AboutComp.TermsandConditions />
      },
      {
        path:"privacypolicy",
        element: <AboutComp.PrivacyPolicy />
      },
      {
        path:"faq",
        element: <AboutComp.FAQ />
      },
      {
        path:"shippingpolicy",
        element: <AboutComp.ShippingPolicy />
      },
      {
        path:"warnings",
        element: <AboutComp.Warnings/>
      },
      {
        path:"returnpolicy",
        element: <AboutComp.ReturnPolicy/>
      },
    ]
  },
  {
    path: "/my",
    element: (
      <Suspense
        fallback={
          <Box sx={loadCenter}>
            <CircularProgress color="secondary" />
          </Box>
        }
      >
        <ProtectedRoute Component={LazyAccount} />
      </Suspense>
    ),
    children: [
      {
        path: "account",
        element: <AccountComp.MyAccount />
      },
      {
        path: "edit-account",
        element: <AuthComp.Register />
      },
      {
        path:"update-password",
        element: <AuthComp.UpdatePassword />
      },
      {
        path:"wish-list",
        element: <AccountComp.WishList />
      },
      {
        path:"order-history",
        element: <AccountComp.OrderHistory />
      },
      {
        path:"order-detail/:id",
        element: <AccountComp.OrderDetail />
      },
      {
        path:"address-book",
        element: <AccountComp.AddressBook />
      },
      {
        path:"cart",
        element: <AccountComp.Cart />
      },
      {
        path: "checkout",
        element: <AccountComp.MyCheckout />
      },
      {
        path: "thankyou",
        element: <AccountComp.Thankyou />
      }

    ]
  },
  {
    path: "/category/:id",
    element: (
      <Suspense
        fallback={
          <Box sx={loadCenter}>
            <CircularProgress color="secondary" />
          </Box>
        }
      >
        <LazyProductCategory />
      </Suspense>
    ),
   
  },
  {
    path: "/product",
    element: (
      <Suspense
        fallback={
          <Box sx={loadCenter}>
            <CircularProgress color="secondary" />
          </Box>
        }
      >
        <LazySearcedProduct />
      </Suspense>
    ),
   
  },
  {
    path: "/product/detail/:id",
    element: (
      <Suspense
        fallback={
          <Box sx={loadCenter}>
            <CircularProgress color="secondary" />
          </Box>
        }
      >
        <LazyProductDetail />
      </Suspense>
    ),
   
  },
  {
    path: "/product/newarrival",
    element: (
      <Suspense
        fallback={
          <Box sx={loadCenter}>
            <CircularProgress color="secondary" />
          </Box>
        }
      >
        <LazyProductNewArrival />
      </Suspense>
    ),
   
  },
  {
    path: "/checkout",
    element: (
      <Suspense
        fallback={
          <Box sx={loadCenter}>
            <CircularProgress color="secondary" />
          </Box>
        }
      >
        <LazyCheckout />
      </Suspense>
    ),
   
  },
  {
    path:"*",
    element:<NotFound />
  }
 
]);
